import { Separator } from "@/components/ui/separator";
import SectionContainer from "@/components/common/SectionContainer";
export default function BiodiversityInformation() {
  return <section id="biodiversity-information" className="bg-background py-16 md:py-24">
      <SectionContainer>
        <div className="max-w-5xl">
          <div className="space-y-6 text-left">
            <h2 className="font-default text-2xl md:text-3xl font-bold italic text-foreground">
              Experience lakeside Glamping in a rich Biodiverse Habitat.
            </h2>
            
            <p className="text-lg md:text-xl italic text-muted-foreground">
              Paradise Cove is recognized as one of the regions leading urban wildlife habitat & migratory bird stop over.
            </p>
            
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Grapevine, Texas sits on the border of one of the most rare and unique portions of the Great Plains that stretches from Mexico all the way into Canada. Called the Cross-Timbers Region, it is a unique narrow strip that divides the East Texas Blackland Prairies from the West Texas Grasslands Prairies. Thanks to the unique flora and fauna this provides and water sources like Lake Grapevine, this area is part of one of the largest and most diverse flyways for bird migration.
            </p>
          </div>

          <div className="mt-16 md:mt-24 flex items-center justify-center w-full">
            <Separator className="flex-1 bg-primary/30 h-[2px]" />
            <h3 className="font-default text-lg md:text-2xl uppercase tracking-wider px-4 md:px-8 text-foreground text-center">
              Book your wedding or event now!
            </h3>
            <Separator className="flex-1 bg-primary/30 h-[2px]" />
          </div>
        </div>
      </SectionContainer>
    </section>;
}